import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import Box from "@material-ui/core/Box";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import clsx from "clsx";
import { Grid, Select, Tooltip, Typography } from "@material-ui/core";
import profile from "../../../../../assets/svg/dashboard/profile-iconRound.svg";
import { Link } from "react-router-dom";
import * as moment from "moment";
import "./style.scss";
import { useWindowDimensions } from "../../../../common/windowsize";
import * as CryptoJS from "crypto-js";
import { PROFILE_KEY } from "../../../../common/constants/actionConstants";
const useStyles = makeStyles((theme) => ({
  table: {
    overflow: "hidden",
    [theme.breakpoints.down("md")]: {
      overflowX: "hidden",
    },
  },
  tableRightBorder: {
    borderRightWidth: 1,
    borderBottomWidth: 1,
    borderColor: "rgba(0,0,0,0.1)",
    borderStyle: "solid",
    // whiteSpace: "nowrap",
  },

  tableFont: {
    fontSize: "16px",
    fontFamily: "Montserrat",
    [theme.breakpoints.down("md")]: {
      display: "flex",
      justifyContent: "right",
      textAlign: "right",
      position: "relative",
      paddingLeft: "100px",
      fontSize: "13px",
    },
  },
  tableHeader: {
    fontSize: "16px",
    fontFamily: "Montserrat",
    color: "#212529",
    fontWeight: 600,
    [theme.breakpoints.down("md")]: {
      position: "absolute",
      left: "5px",
      top: "16px",
      width: "150px",
      textAlign: "left",
      fontSize: "12px",
    },
    [theme.breakpoints.down("sm")]: {
      position: "absolute",
      left: "5px",
      top: "6px",
      width: "150px",
      textAlign: "left",
      fontSize: "12px",
    },
  },
  root: {
    marginBottom: "30px",
    overflow: "hidden !important",
    [theme.breakpoints.down("md")]: {
      overflowX: "hidden !important",
    },
  },
  lessWidth2: {
    width: "60px",
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
  },
  lessWidth3: {
    width: "100px",
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
  },
  commonWidth: {
    width: "450px",
    boxSizing: "border-box",
    height: "150px",
    maxHeight: "150px",
  },
  lessWidth: {
    width: "60px",
    fontSize: "16px",
    fontFamily: "Montserrat",
    "&:hover": {
      cursor: "pointer",
    },
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
  },
  tooltip: {
    backgroundColor: "#816ab0",
    // backgroundColor: '#efefef'
  },
  tooltip3: {
    backgroundColor: "#816ab0",
    maxWidth: "550px",
  },
  tooltipTy: {
    color: "#fff",
    fontFamily: "Montserrat",
    fontSize: "16px",
  },
  tooltipPopper: {
    width: "400px",
  },
  number: {
    [theme.breakpoints.down("md")]: {
      marginTop: "40px",
      borderTop: "1px solid rgba(0,0,0,0.4)",
    },
  },
}));

export default function BasicTable(props) {
  class AesUtil {
    constructor(keySize, iterationCount) {
      this.keySize = keySize / 32;
      this.iterationCount = iterationCount;
    }
  
    generateKey = function (salt, passPhrase) {
      let key = CryptoJS.PBKDF2(passPhrase, CryptoJS.enc.Hex.parse(salt), {
        keySize: this.keySize,
        iterations: this.iterationCount,
      });
      return key;
    };
  
    encrypt = function (salt, iv, passPhrase, plainText) {
      let key = this.generateKey(salt, passPhrase);
      let encrypted = CryptoJS.AES.encrypt(plainText, key, {
        iv: CryptoJS.enc.Hex.parse(iv),
      });
      return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
    };
  }
  const encryptAES2 = (text, key) => {
    // let iv = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
    // let salt = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
  
    // let aesUtil = new AesUtil(128, 1000);
    // let ciphertext = aesUtil.encrypt(salt, iv, key, text);
  
    // let aesText = iv + "::" + salt + "::" + ciphertext;
    
    return btoa(text);
  };
  const classes = useStyles();
  const { data } = props;

  const dimension = useWindowDimensions();
  const small = dimension.width < 500;

  const HeaderItem = (props) => {
    return small ? <div className={classes.tableHeader}>{props.t}</div> : "";
  };

  return (
    <div className="messagetable-mom">
      <Box className={classes.root}>
        <TableContainer component={Paper}>
          <Table className={classes.table} aria-label="simple table">
            {data?.length > 0 ? (
              <>
                {!small && (
                  <TableHead>
                    <TableRow>
                      <TableCell
                        className={clsx(
                          classes.tableRightBorder,
                          classes.tableHeader,
                          classes.lessWidth2
                        )}
                      >
                        NO.
                      </TableCell>
                      <TableCell
                        className={clsx(
                          classes.tableRightBorder,
                          classes.tableHeader,
                          classes.lessWidth3
                        )}
                      >
                        MENTORSHIP REQUIREMENT ID
                      </TableCell>

                      <TableCell
                        className={clsx(
                          classes.tableRightBorder,
                          classes.tableHeader,
                          classes.lessWidth3
                        )}
                      >
                        REQUIREMENT DATE
                      </TableCell>

                      <TableCell
                        className={clsx(
                          classes.tableRightBorder,
                          classes.tableHeader
                        )}
                      >
                        MATCH <br />
                        TABLE
                      </TableCell>
                      <TableCell
                        className={clsx(
                          classes.tableRightBorder,
                          classes.tableHeader
                        )}
                      >
                        REQUEST SENT TO MENTOR
                      </TableCell>
                      <TableCell
                        className={clsx(
                          classes.tableRightBorder,
                          classes.tableHeader
                        )}
                      >
                        PURPOSE OF REQUEST
                      </TableCell>
                      <TableCell
                        className={clsx(
                          classes.tableRightBorder,
                          classes.tableHeader,
                          classes.lessWidth3
                        )}
                      >
                        MENTOR REQUEST STATUS
                      </TableCell>
                    </TableRow>
                  </TableHead>
                )}
                <TableBody>
                  {data?.map((datum, index) => {
                    return datum?.mentorRequests?.length > 0 ? (
                      datum?.mentorRequests?.map((req, index2) => (
                        <TableRow
                          key={index}
                          style={{
                            backgroundColor:
                              props.selectedRow == index ? "#e2d2ed" : "",
                          }}
                        >
                          {index2 === 0 && (
                            <>
                              <TableCell
                                rowSpan={
                                  !small
                                    ? datum?.mentorRequests?.length || 1
                                    : 1
                                }
                                className={clsx(
                                  classes.tableRightBorder,
                                  classes.tableFont,
                                  classes.lessWidth2,
                                  { [classes.number]: index > 0 }
                                )}
                              >
                                <HeaderItem t="NO." />
                                {(parseInt(props.currentPage) - 1) * 10 +
                                  (index + 1)}
                              </TableCell>
                              <TableCell
                                rowSpan={
                                  !small
                                    ? datum?.mentorRequests?.length || 1
                                    : 1
                                }
                                className={clsx(
                                  classes.tableRightBorder,
                                  classes.tableFont,
                                  classes.lessWidth3
                                )}
                              >
                                <HeaderItem t="MENTORSHIP REQUIREMENT ID" />
                                <Tooltip
                                  classes={{
                                    tooltip: classes.tooltip,
                                    tooltipArrow: classes.tooltipArrow,
                                  }}
                                  PopperProps={{
                                    disablePortal: true,
                                  }}
                                  arrow
                                  title={
                                    <Typography
                                      style={{
                                        fontFamily: "Montserrat",
                                        fontSize: "14px",
                                        color: "#fff",
                                        fontWeight: "bold",
                                        padding: 0,
                                        margin: 0,
                                      }}
                                    >
                                      View Requirement
                                    </Typography>
                                  }
                                >
                                  <Link
                                    onClick={() => {
                                      props.setModalData(datum.requestJson);
                                      props.setModalOpen(true);
                                    }}
                                    style={{
                                      color: "#277acc",
                                      cursor: "pointer",
                                      textDecoration: "underline",
                                    }}
                                  >
                                    {datum?.requestId?.substr(
                                      datum?.requestId?.length - 6
                                    )}
                                  </Link>
                                </Tooltip>
                              </TableCell>
                              <TableCell
                                rowSpan={
                                  !small
                                    ? datum?.mentorRequests?.length || 1
                                    : 1
                                }
                                style={{
                                  whitespace: "nowrap",
                                  padding: "10px",
                                  // fontSize: "15px",
                                }}
                                className={clsx(
                                  classes.tableRightBorder,
                                  classes.tableFont,
                                  classes.lessWidth3,'forfonta'
                                )}
                              >
                                <HeaderItem t="REQUIREMENT DATE" />
                                {moment(datum?.applicationDate).format(
                                  "DD/MM/YYYY"
                                )}
                                <br />
                                {moment(datum?.applicationDate).format(
                                  "hh:mm A"
                                )}
                              </TableCell>
                              <TableCell
                                rowSpan={datum?.mentorRequests?.length || 1}
                                className={clsx(
                                  classes.tableRightBorder,
                                  classes.tableFont
                                )}
                              >
                                <HeaderItem t="MATCH TABLE" />
                                {datum?.mentorRequests &&
                                datum?.mentorRequests?.length > 0 &&
                                datum?.mentorRequests[0].match === true ? (
                                  "Request is sent directly to Mentor"
                                ) : (
                                  <Tooltip
                                    classes={{
                                      tooltip: classes.tooltip,
                                      tooltipArrow: classes.tooltipArrow,
                                    }}
                                    PopperProps={{
                                      disablePortal: true,
                                    }}
                                    arrow
                                    title={
                                      <Typography
                                        style={{
                                          fontFamily: "Montserrat",
                                          fontSize: "14px",
                                          color: "#fff",
                                          fontWeight: "bold",
                                          padding: 0,
                                          margin: 0,
                                        }}
                                      >
                                        View Match Table
                                      </Typography>
                                    }
                                  >
                                    <Link
                                      style={{
                                        color: "#277acc",
                                        textDecoration: "underline",
                                      }}
                                      onClick={() => {
                                        props.setSelectedRow(index);
                                        window.open(
                                          `/startup-dashboard/match-list/${datum?.searchId}`,
                                          "_blank"
                                        );
                                      }}
                                    >
                                      View
                                    </Link>
                                  </Tooltip>
                                )}
                              </TableCell>
                            </>
                          )}

                          <TableCell
                            className={clsx(
                              classes.tableRightBorder,
                              classes.tableFont,
                              "tablefontrrr"
                            )}
                            style={{
                              alignItems: "center",
                              position: "relative",
                            }}
                          >
                            <HeaderItem t="REQUEST SENT TO MENTOR" />
                            {req?.mentorName}
                            <Tooltip
                              classes={{
                                tooltip: classes.tooltip,
                                tooltipArrow: classes.tooltipArrow,
                              }}
                              PopperProps={{
                                disablePortal: true,
                              }}
                              arrow
                              title={
                                <Typography
                                  style={{
                                    fontFamily: "Montserrat",
                                    fontSize: "14px",
                                    color: "#fff",
                                    fontWeight: "bold",
                                    padding: 0,
                                    margin: 0,
                                  }}
                                >
                                  View Mentor Profile
                                </Typography>
                              }
                            >
                              <img
                                className="profileOfMentor"
                                src={profile}
                                // style={{
                                //   position: "absolute",
                                //   bottom: 10,
                                //   right: 10,
                                //   height: "40px",
                                //   width: "40px",
                                // }}
                                onClick={() => {
                                  let sample;
                                  const currentRoute = window.location.href;
                                  sample = currentRoute.slice(
                                    0,
                                    currentRoute.lastIndexOf("/")
                                  );
                                  let reRoute = window.open(sample + `/mentor-profile/${encryptAES2(req?.mentorEmail,PROFILE_KEY)}`, "_blank");
                                  // let reRoute = window.open(
                                  //   `/mentor-profile/${req?.mentorEmail}`,
                                  //   "_blank"
                                  // );
                                  reRoute.id = req?.mentorEmail;
                                }}
                              />
                            </Tooltip>
                          </TableCell>
                          <TableCell
                            style={{
                              borderBottomWidth:
                                index === datum.mentorRequests.length - 1
                                  ? 1
                                  : 1,
                            }}
                            className={clsx(
                              classes.tableRightBorder,
                              classes.tableFont,
                              "tablefontrrr"
                            )}
                          >
                            <HeaderItem t="PURPOSE OF REQUEST" />
                            <Tooltip
                              classes={{
                                tooltip: classes.tooltip3,
                                tooltipArrow: classes.tooltip,
                              }}
                              title={
                                <Typography className={classes.tooltipTy}>
                                  {req?.purposeOfMentorship}
                                </Typography>
                              }
                              placement="left"
                              arrow
                            >
                              <Typography className="typographdata">
                                {req?.purposeOfMentorship?.slice(0, 40)}
                                {req?.purposeOfMentorship?.length > 40 && "..."}
                              </Typography>
                            </Tooltip>
                          </TableCell>
                          <TableCell
                            style={{
                              borderRightWidth: 0,
                              borderBottomWidth:
                                index === datum.mentorRequests.length - 1
                                  ? 1
                                  : 1,
                            }}
                            className={clsx(
                              classes.tableRightBorder,
                              classes.tableFont,
                              classes.lessWidth3
                            )}
                          >
                            <HeaderItem t="MENTOR REQUEST STATUS" />
                            {req?.requestStatus}
                          </TableCell>

                          {/* <Box className={classes.subtable}>
                              <Box
                                className={clsx(
                                  classes.subtableBox,
                                  classes.commonWidth
                                )}
                              ></Box>
                              <Box
                                className={clsx(
                                  classes.subtableBox,
                                  classes.commonWidth
                                )}
                              ></Box>
                              <Box className={classes.subtableBox}></Box>
                            </Box> */}
                        </TableRow>
                      ))
                    ) : (
                      <TableRow
                        key={index}
                        style={{
                          backgroundColor:
                            props.selectedRow == index ? "#e2d2ed" : "",
                        }}
                      >
                        <TableCell
                          className={clsx(
                            classes.tableRightBorder,
                            classes.tableFont,
                            classes.lessWidth2,
                            classes.number
                          )}
                        >
                          <HeaderItem t="NO." />
                          {(parseInt(props.currentPage) - 1) * 10 + (index + 1)}
                        </TableCell>
                        <TableCell
                          className={clsx(
                            classes.tableRightBorder,
                            classes.tableFont
                          )}
                        >
                          <HeaderItem t="MENTORSHIP REQUIREMENT ID" />
                          <Tooltip
                            classes={{
                              tooltip: classes.tooltip,
                              tooltipArrow: classes.tooltipArrow,
                            }}
                            PopperProps={{
                              disablePortal: true,
                            }}
                            arrow
                            title={
                              <Typography
                                style={{
                                  fontFamily: "Montserrat",
                                  fontSize: "14px",
                                  color: "#fff",
                                  fontWeight: "bold",
                                  padding: 0,
                                  margin: 0,
                                }}
                              >
                                View Requirement
                              </Typography>
                            }
                          >
                            <Link
                              onClick={() => {
                                props.setModalData(datum.requestJson);
                                props.setModalOpen(true);
                              }}
                              style={{
                                color: "#277acc",
                                cursor: "pointer",
                                textDecoration: "underline",
                              }}
                            >
                              {datum?.requestId?.substr(
                                datum?.requestId?.length - 6
                              )}
                            </Link>
                          </Tooltip>
                        </TableCell>
                        <TableCell

                          style={{
                            whitespace: "nowrap",
                            padding: "10px",
                            // fontSize: "15px",
                          }}
                          className={clsx(
                            classes.tableRightBorder,
                            classes.tableFont,'forfonta'
                          )}
                        >
                          <HeaderItem t="REQUIREMENT DATE" />
                          {moment(datum?.applicationDate).format("DD/MM/YYYY")}
                          <br />
                          {moment(datum?.applicationDate).format("hh:mm A")}
                        </TableCell>
                        <TableCell
                          className={clsx(
                            classes.tableRightBorder,
                            classes.tableFont
                          )}
                        >
                          <HeaderItem t="MATCH TABLE" />
                          {datum?.mentorRequests &&
                          datum?.mentorRequests?.length > 0 &&
                          datum?.mentorRequests[0].match === true ? (
                            "Request is sent directly to Mentor"
                          ) : (
                            <Tooltip
                              classes={{
                                tooltip: classes.tooltip,
                                tooltipArrow: classes.tooltipArrow,
                              }}
                              PopperProps={{
                                disablePortal: true,
                              }}
                              arrow
                              title={
                                <Typography
                                  style={{
                                    fontFamily: "Montserrat",
                                    fontSize: "14px",
                                    color: "#fff",
                                    fontWeight: "bold",
                                    padding: 0,
                                    margin: 0,
                                  }}
                                >
                                  View Match Table
                                </Typography>
                              }
                            >
                              <Link
                                style={{
                                  color: "#277acc",
                                  textDecoration: "underline",
                                }}
                                onClick={() => {
                                  props.setSelectedRow(index);
                                  window.open(
                                    `/startup-dashboard/match-list/${datum?.searchId}`,
                                    "_blank"
                                  );
                                }}
                              >
                                View
                              </Link>
                            </Tooltip>
                          )}
                        </TableCell>
                        {!small && (
                          <>
                            <TableCell
                              className={clsx(
                                classes.tableRightBorder,
                                classes.tableFont
                              )}
                            ></TableCell>
                            <TableCell
                              style={{
                                borderBottomWidth:
                                  index === datum.mentorRequests.length - 1
                                    ? 1
                                    : 1,
                              }}
                              className={clsx(
                                classes.tableRightBorder,
                                classes.tableFont
                              )}
                            ></TableCell>
                            <TableCell
                              style={{
                                borderRightWidth: 0,
                                borderBottomWidth:
                                  index === datum.mentorRequests.length - 1
                                    ? 1
                                    : 1,
                              }}
                              className={clsx(
                                classes.tableRightBorder,
                                classes.tableFont
                              )}
                            ></TableCell>
                          </>
                        )}
                      </TableRow>
                    );
                  })}
                </TableBody>
              </>
            ) : (
              <>
                <tr colSpan={8} style={{ border: "none" }}>
                  <td
                    className="d-flex justify-content-center"
                    style={{ border: "none" }}
                  >
                    {" "}
                    <div
                      className="no-records"
                      style={{
                        position: "relative",
                        left: "0px",
                        whiteSpace: "nowrap",
                      }}
                    >
                      No Records Found
                    </div>
                  </td>
                </tr>
              </>
            )}
          </Table>
        </TableContainer>
      </Box>
    </div>
  );
}
